const BILLING_TYPES = {
  prepaid: 'Prepaid',
  postpaid: 'Postpaid'
}

const IS_PREPAID_DEFAULT = true

export default { BILLING_TYPES, IS_PREPAID_DEFAULT }
